/* eslint-disable eqeqeq */
import { Button, Checkbox, Form, Input, Toast } from "antd-mobile-v5";
import { useCallback, useState } from "react";
import { useWindowSize } from "react-use";
import styled from "styled-components";
import { EyeInvisibleOutline, EyeOutline } from "antd-mobile-icons";
import CryptoJs from "crypto-js";
import instance from "../../util/axios";
const TiktokWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: scroll;
  .head {
    width: 100%;
  }
  .list {
    flex: 1;
    background: #fff;
    padding: 24px;
    padding-top: 4px;
  }
  .password {
    display: flex;
    align-items: center;
    .input {
      flex: auto;
    }
    .eye {
      flex: none;
      margin-left: 8px;
      padding: 4px;
      cursor: pointer;
      svg {
        display: block;
        font-size: var(--adm-font-size-7);
      }
    }
  }
`;
let maxTime = 60;
export default function Tiktok() {
  const [form] = Form.useForm();
  const { height } = useWindowSize();
  const [visible, setVisible] = useState(false);
  const [visibleTwo, setVisibleTwo] = useState(false);
  const [isAgree, setIsAgree] = useState(false);
  const [codeInfo, setCodeInfo] = useState<{
    btnDisabled: boolean;
    btnText: string;
    mobile: string;
  }>({
    btnDisabled: false,
    btnText: "发送验证码",
    mobile: "",
  });
  const onFinish = (values: any) => {
    instance
      .post("/oa/registerDetail/confirmVerifyCode", {
        mobile: values?.mobile,
        inCode: values?.code,
      })
      .then((res: any) => {
        if (res.data.Status === "1") {
          instance
            .post("/oa/registerDetail/registerEnterprise", {
              enterpriseName: values?.enterpriseName,
              contractName: values?.name,
              password: values?.password,
              repassword: values?.repassword,
              mobilePhone: values?.mobile,
              validateCode: "",
              setMeal:
                "06c604b1095c41f2ae205f4d55c5a35f,6d0d010c28154fed862459b39cabcc0c,ec6e6b8c50ac442783381c5342ec288f",
            })
            .then((resp) => {
              if (resp.data.Status === "1") {
                Toast.show({
                  content: "注册成功,请查收短信！",
                });
              } else {
                Toast.show({
                  content: resp.data.Data,
                });
              }
            });
        } else {
          Toast.show({
            content: "验证码错误！",
          });
        }
      });
  };
  const sendCode = useCallback((mobile: string) => {
    const word = CryptoJs.MD5(`${mobile}tysoft`).toString();
    instance
      .post("/oa/registerDetail/newGetVerifyCode", {
        mobile: mobile,
        inCode: word,
      })
      .then((resp) => {
        if (resp.data.Status === "1") {
          Toast.show({
            content: "验证码发送成功",
          });
          const timer = setInterval(() => {
            if (maxTime > 0) {
              --maxTime;
              setCodeInfo((prevState) => ({
                ...prevState,
                btnText: `${maxTime}s`,
                btnDisabled: true,
                mobile: mobile,
              }));
            } else {
              clearInterval(timer);
              maxTime = 60;
              setCodeInfo((prevState) => ({
                ...prevState,
                btnText: "发送验证码",
                btnDisabled: false,
                mobile: mobile,
              }));
            }
          }, 1000);
        } else {
          //
        }
      });
  }, []);

  return (
    <TiktokWrapper style={{ minHeight: height }}>
      <img src="/register/tiktokHead.png" className="head" alt="" />
      <div className="list">
        <Form
          name="form"
          form={form}
          onFinish={onFinish}
          footer={
            <Button
              block
              type="submit"
              color="primary"
              size="large"
              disabled={!isAgree}
            >
              立即注册
            </Button>
          }
        >
          <Form.Item
            name="enterpriseName"
            label="公司名称"
            rules={[{ required: true, message: "公司名称不能为空" }]}
          >
            <Input placeholder="请输入公司名称" />
          </Form.Item>
          <Form.Item
            name="name"
            label="您的称呼"
            rules={[{ required: true, message: "您的称呼不能为空" }]}
          >
            <Input placeholder="请输入您的称呼" />
          </Form.Item>
          <Form.Item
            name="mobile"
            label="手机号"
            rules={[
              { required: true, message: "手机号不能为空" },
              {
                pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                message: "手机号格式错误！",
              },
            ]}
          >
            <Input placeholder="请输入手机号" />
          </Form.Item>
          <Form.Item
            name="code"
            label="验证码"
            rules={[{ required: true, message: "验证码不能为空" }]}
            extra={
              codeInfo.btnDisabled ? (
                <span>{codeInfo.btnText}</span>
              ) : (
                <a
                  onClick={async () => {
                    const mobile = form.getFieldValue("mobile");
                    const re = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                    if (!mobile) {
                      Toast.show({
                        content: "请输入手机号",
                      });
                      return;
                    }
                    if (!re.test(mobile)) {
                      return;
                    }
                    sendCode(form.getFieldValue("mobile"));
                  }}
                >
                  {codeInfo.btnText}
                </a>
              )
            }
          >
            <Input placeholder="请输入验证码" />
          </Form.Item>
          <Form.Item
            name="password"
            label="系统登录密码"
            rules={[
              { required: true, message: "系统登录密码不能为空" },
              {
                pattern: /^[A-Za-z0-9]{6,}$/,
                message: "系统登录密码长度至少六位",
              },
            ]}
          >
            <div className="password">
              <Input
                className="input"
                placeholder="请输入系统登录密码"
                type={visible ? "text" : "password"}
              />
              <div className="eye">
                {!visible ? (
                  <EyeInvisibleOutline onClick={() => setVisible(true)} />
                ) : (
                  <EyeOutline onClick={() => setVisible(false)} />
                )}
              </div>
            </div>
          </Form.Item>
          <Form.Item
            name="repassword"
            label="确认密码"
            rules={[
              { required: true, message: "密码不能为空" },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject("两次输入的密码不匹配");
                },
              }),
              {
                pattern: /^[A-Za-z0-9]{6,}$/,
                message: "密码长度至少六位",
              },
            ]}
          >
            <div className="password">
              <Input
                className="input"
                placeholder="请再次输入"
                type={visibleTwo ? "text" : "password"}
              />
              <div className="eye">
                {!visibleTwo ? (
                  <EyeInvisibleOutline onClick={() => setVisibleTwo(true)} />
                ) : (
                  <EyeOutline onClick={() => setVisibleTwo(false)} />
                )}
              </div>
            </div>
          </Form.Item>
        </Form>
        <Checkbox
          checked={isAgree}
          onChange={(checked: any) => {
            setIsAgree(checked);
          }}
        >
          已阅读并同意
          <a href="https://i.tysoft.com/register/agreement">《软湖使用条款》</a>
        </Checkbox>
      </div>
    </TiktokWrapper>
  );
}
